import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c("AppPerfil", {
        attrs: { nome: _vm.usuario.nome, titulo: "Perfil" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  [
                    _c(
                      VCol,
                      [
                        _c(
                          VTabs,
                          {
                            attrs: { centered: "", "icons-and-text": "" },
                            model: {
                              value: _vm.categoria,
                              callback: function ($$v) {
                                _vm.categoria = $$v
                              },
                              expression: "categoria",
                            },
                          },
                          [
                            _c(VTabsSlider, {
                              attrs: { color: "secondary" },
                            }),
                            _vm._l(_vm.categorias.length, function (i) {
                              return _c(
                                VTab,
                                {
                                  key: i,
                                  staticClass: "mt-3",
                                  attrs: {
                                    href: "#" + _vm.categorias[i - 1].id,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "grey--text text--darken-2",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.categorias[i - 1].descricao)
                                      ),
                                    ]
                                  ),
                                  _c(
                                    VIcon,
                                    {
                                      attrs: {
                                        color:
                                          _vm.categorias[i - 1].id ===
                                          _vm.categoria
                                            ? "secondary"
                                            : "grey",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.categorias[i - 1].icone) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  VRow,
                  { staticClass: "pa-8 pt-4 pb-4" },
                  [
                    _c(
                      "keep-alive",
                      [
                        _c(_vm.currentComponent, {
                          key: _vm.currentComponent,
                          tag: "component",
                          attrs: { perfil: _vm.usuario.perfil },
                          on: {
                            updatePerfil: (value) => _vm.updatePerfil(value),
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  VRow,
                  { attrs: { dense: "", "no-gutters": "" } },
                  [
                    _vm.categoriaAnterior
                      ? _c(
                          VBtn,
                          {
                            staticClass: "mr-2",
                            attrs: { color: "secondary", outlined: "" },
                            on: {
                              click: function ($event) {
                                return _vm.previous()
                              },
                            },
                          },
                          [
                            _c(VIcon, { staticClass: "mr-2" }, [
                              _vm._v(" keyboard_arrow_left "),
                            ]),
                            _vm._v(" ANTERIOR "),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      VBtn,
                      {
                        attrs: { color: "secondary", outlined: "" },
                        on: {
                          click: function ($event) {
                            return _vm.next()
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.categoriaPosterior ? "PRÓXIMO" : "FINALIZAR"
                            ) +
                            " "
                        ),
                        _c(VIcon, { staticClass: "ml-2" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.categoriaPosterior
                                  ? "keyboard_arrow_right"
                                  : "check"
                              ) +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-agradecimento", {
        attrs: {
          "dialog-visible": _vm.dialogs.dialogAgradecimento.visibilidade,
          "toogle-visible": _vm.toogleDialogAgradecimento,
          descricao:
            "Agradecemos pela sua colaboração!\n          Você ainda poderá alterar as informações cadastradas a qualquer momento.",
          "url-redirecionamento": "/perfil",
        },
      }),
      _c("dialog-termo-responsabilidade", {
        attrs: { "dialog-props": _vm.dialogs.dialogTermoResponsabilidade },
      }),
      _c("dialog-info", { attrs: { value: _vm.aviso } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }